export enum FilterType {
  String,
  Boolean,
  Range
}
